import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Icon from './Stormwater2.jpg';

const Nav2 = (props) => {  

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const activateOnKey = (handler) => (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handler();
        }
    };

    return (

        <Navbar className="customNavbar" collapseOnSelect expand="md" variant="dark">
            <Navbar.Brand href="https://www.roanokeva.gov/500/Stormwater" target="_blank">
                <img id="navIcon" src={`./` + Icon} alt="stormwater logo"></img>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                    <span id="navMainline">City of Roanoke <p id="navSub">STORMWATER UTILITY</p></span>
                    <span id="navTagline">Real Time Flood Inundation Application</span>
                </Nav>
                <Nav>
                    <span id="dashboardActions">
                        <span className={(props.dashboardView && props.dashboardView === "current") ? "viewSpan active" : "viewSpan" } id="current" role="button" tabIndex={0} onClick={() => props.setDashboardAndSlider("current")} onKeyDown={activateOnKey(() => props.setDashboardAndSlider("current"))}>Current Status</span> <span> | </span>
                        <span className={(props.dashboardView && props.dashboardView === "forecast") ? "viewSpan active" : "viewSpan"} id="forecast" role="button" tabIndex={0} onClick={() => props.setDashboardAndSlider("forecast")} onKeyDown={activateOnKey(() => props.setDashboardAndSlider("forecast"))}>Forecast </span> <span> | </span>
                        <span className={(props.dashboardView && props.dashboardView === "scenario") ? "viewSpan active" : "viewSpan"} id="scenario" role="button" tabIndex={0} onClick={() => props.setDashboardAndSlider("scenario")} onKeyDown={activateOnKey(() => props.setDashboardAndSlider("scenario"))}>Scenario </span> <span> | </span>
                        <span className="viewSpan" id="contact" role="button" tabIndex={0} onClick={handleShow} onKeyDown={activateOnKey(handleShow)}>Contact </span>
                    </span>
                </Nav>
            </Navbar.Collapse>

            <Modal className="contactModal" centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="contactModalTitle">For More Information</Modal.Title>
                </Modal.Header>
                <Modal.Body className="contactModalBody">

                    <h4 className="contactModalSubtitle">Address</h4>
                    <p>
                        City of Roanoke Stormwater Utility
                        <br></br>
                        Public Works Service Center
                        <br></br>
                        1802 Courtland Road NE
                        <br></br>
                        Roanoke, VA 24012
                    </p>

                    {/*<h4 className="contactModalSubtitle">Office Hours</h4>
                    <p>
                        Monday - Friday
                        <br></br>
                        8 a.m. - 5 p.m.
                    </p>

                    <h4 className="contactModalSubtitle">Hours of Operation</h4>
                    <p>
                        Monday - Friday
                        <br></br>
                        7:30 a.m. - 4:30 p.m.
                    </p>*/}

                    <h4 className="contactModalSubtitle">Phone</h4>
                    <p>540-853-5900</p>

                    <h4 className="contactModalSubtitle">Online</h4>
                    <p>
                        <a href="http://www.roanokeva.gov/stormwater" target="_blank">Visit our Website</a>
                        <br></br>
                        <a href="mailto:stormwater@roanokeva.gov" target="_self">Email the Department</a>
                    </p>


                </Modal.Body>
            </Modal>
        </Navbar>

        )
}


export default Nav2;


// WEBPACK FOOTER //
// ./src/components/Nav2/index.js